import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  aside: {
    padding: '0.5rem 0.75rem',
    marginInline: '-0.75rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    backgroundColor: neutral[10],
  },
  title: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
  },
  btn: {
    padding: '0.5rem 0rem',
    justifyContent: 'space-between',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[100],
  },
});
